import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	deactivated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deactivated: {
		id: 'project-components.lead.deactivated-status',
		defaultMessage: '{userName} <status>(Deactivated)</status>',
		description:
			'Text displayed to the right of the user name of a deactivated user in user picker field',
	},
});
export default messages;
